import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-store-image-popup',
  templateUrl: './store-image-popup.component.html',
  styleUrls: ['./store-image-popup.component.scss']
})
export class StoreImagePopupComponent implements OnInit {

  currentIndex: number = 0;
  @ViewChild('thumbnailScroll') thumbnailScroll!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<StoreImagePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { images: any[], startIndex: number }
  ) {
    this.currentIndex = data.startIndex;
  }

  nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.data.images.length;
    this.scrollToCurrentThumbnail();
  }

  prevImage() {
    this.currentIndex = (this.currentIndex - 1 + this.data.images.length) % this.data.images.length;
    this.scrollToCurrentThumbnail();
  }

  scrollThumbnails(direction: number) {
    const scrollAmount = 100; // Adjust scroll speed
    this.thumbnailScroll.nativeElement.scrollLeft += direction * scrollAmount;
  }

  scrollToCurrentThumbnail() {
    const thumbnails = this.thumbnailScroll.nativeElement.children;
    if (thumbnails[this.currentIndex]) {
      thumbnails[this.currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'center' });
    }
  }



  ngOnInit(): void {
  }



}
